import { render } from "./About.vue?vue&type=template&id=7e953c45&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=7e953c45&scoped=true&lang=css"

import exportComponent from "G:\\官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e953c45"]])

export default __exports__